<template>
    <HeaderAdmin></HeaderAdmin>
    <main>
        <section class="admin__container">
                <SideBar></SideBar>
                <RightContentWrapper>
                    <template #title>Orders</template>
                    <template #desc>Here the place where you can check status of your orders</template>
                    <template #content><OrderContent></OrderContent></template>
                </RightContentWrapper>
        </section>
    </main>
</template>

<script>
import HeaderAdmin from '@/components/Header/HeaderAdmin.vue';
import SideBar from '@/components/UserGroups/Admins/SideBar.vue';
import RightContentWrapper from '@/components/UserGroups/Admins/RightContentWrapper.vue';
import OrderContent from '@/components/UserGroups/Admins/OrderContent.vue';
    export default {
        components: {
            HeaderAdmin,
            SideBar,
            RightContentWrapper,
            OrderContent
        },
    }
</script>

<style scoped>
</style>